
import MxInfoModal from '@/components/global/MxInfoModal.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'SubmitIdeas',
    components: {
        MxInfoModal
    }
})
export default class DashboardAppInfo extends Vue {


}

